var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.413 63.9965C9.85681 63.9929 6.44728 62.5785 3.93263 60.0639C1.41799 57.5493 0.00366339 54.1397 0 50.5835V13.4131C0 9.85569 1.41316 6.44403 3.92859 3.92859C6.44403 1.41316 9.85568 0 13.413 0H50.5835C54.1397 0.00366339 57.5493 1.418 60.0639 3.93264C62.5785 6.44729 63.9929 9.85682 63.9965 13.4131V50.5835C63.9929 54.1397 62.5785 57.5493 60.0639 60.0639C57.5493 62.5785 54.1397 63.9929 50.5835 63.9965H13.413Z",
    fill: "#895E4D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5835 0H13.413C9.85568 0 6.44403 1.41316 3.92859 3.92859C1.41316 6.44402 0 9.85569 0 13.4131V50.5835C0.00366339 54.1397 1.41799 57.5493 3.93263 60.0639C6.44728 62.5785 9.85681 63.9929 13.413 63.9965H50.5835C54.1397 63.9929 57.5493 62.5785 60.0639 60.0639C62.5785 57.5493 63.9929 54.1397 63.9965 50.5835V13.4131C63.9929 9.85682 62.5785 6.44729 60.0639 3.93264C57.5493 1.418 54.1397 0.00366339 50.5835 0ZM62.5504 48.307C62.5449 51.7003 61.1945 54.953 58.7951 57.3524C56.3957 59.7518 53.143 61.1022 49.7497 61.1077H14.2537C10.8607 61.1013 7.60856 59.7506 5.20935 57.3514C2.81014 54.9522 1.45945 51.7 1.45305 48.307V12.818C1.45305 9.42304 2.80169 6.16713 5.20229 3.76654C7.60288 1.36594 10.8588 0.0173046 14.2537 0.0173046H49.7428C53.1361 0.0227938 56.3888 1.37319 58.7882 3.7726C61.1876 6.172 62.538 9.42473 62.5435 12.818L62.5504 48.307Z",
    fill: "#E89B3F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFrame);
export default __webpack_public_path__ + "static/media/avatar_frame.f69f39966fc4438efae33a3815f222d9.svg";
export { ForwardRef as ReactComponent };